import { IContestMaintenance } from "../../types/contest-maintenance.type";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";

const API_URL = `${import.meta.env.VITE_API_URL}/contest-maintenance`;

export async function getContestMaintenances({
  status = "",
  search = "",
  page = 1,
  itemsPerPage = 10,
  orderBy = "-createdAt",
} = {}) {
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
    orderBy,
  });

  status && params.append("filters[status]", status);
  search && params.append("search", search);

  const url = `${API_URL}/?${params.toString()}`;
  const result = (await makeRequest(url)) as ApiResponseType<
    Record<string, unknown>[]
  > & { totalItems: number };

  return { ok: result.ok, data: result.data, totalItems: result.totalItems };
}

export async function respondContestMaintenance(
  id: string,
  variables: { status: string, resolution: string }
): Promise<ApiResponseType<IContestMaintenance>> {
  const url = `${API_URL}/${id}`;
  const options = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(variables),
  };

  const response = await makeRequest<ApiResponseType<IContestMaintenance>>(url, options);

  if (!response.ok) {
    throw new Error(response.message ?? "Erro ao responder contestação");
  }

  return response.data;
}



export async function getContestMaintenanceById(id: string) {
  const url = `${API_URL}/${id}`;
  return makeRequest(url) as Promise<ApiResponseType<IContestMaintenance>>;
}
